import React from 'react'
import { Dropdown, Menu } from 'antd'
import { DownOutlined } from '@ant-design/icons'
import moment from 'lib/localizedMoment'
import Button from 'components/shared/Button'
import Price from 'components/shared/Price'

const TimeSlotPicker = ({
  pendingBookings,
  onSelect,
  isBeingSelected,
  disabled = false,
}) => {
  const menu = (
    <Menu
      onClick={(item) => {
        const bookingToReserve = pendingBookings.find(
          (pb) => pb.id === item.key
        )
        onSelect(bookingToReserve)
      }}
    >
      {pendingBookings.map((pendingBooking) => {
        const timeString = `${moment(pendingBooking.startsAt).format('HH:mm')} - ${moment(pendingBooking.endsAt).format('HH:mm')}`
        return (
          <Menu.Item key={pendingBooking.id}>
            {timeString}
            {!!pendingBooking.bookingFee && (
              <>
                {' '}
                (+ <Price price={pendingBooking.bookingFee} />)
              </>
            )}
          </Menu.Item>
        )
      })}
    </Menu>
  )
  return (
    <Dropdown overlay={menu} disabled={disabled}>
      <Button loading={isBeingSelected}>
        Velg tidspunkt <DownOutlined />
      </Button>
    </Dropdown>
  )
}

export default TimeSlotPicker
